module.exports = __webpack_public_path__ + "img/Slice 268@2x(8).e2161045.png";